import { requestType, CREATOR_ENDPOINTS } from "../../constants/Variables";
import Api from "../index";

const getCreatorCampaigns = (creatorId, params) => {
  const url = CREATOR_ENDPOINTS.CAMPAIGN.GET_ALL.replace(":creatorId", creatorId);
  const queryParams = new URLSearchParams();
  if (params?.page) queryParams.append("page", params.page);
  if (params?.limit) queryParams.append("limit", params.limit);
  if (params?.search) queryParams.append("search", params.search);

  const finalUrl = queryParams.toString()
    ? `${url}?${queryParams.toString()}`
    : url;

  return Api(finalUrl, null, requestType.GET);
};

const getCreatorAcceptedCampaigns = (creatorId) => {
  return Api(
    CREATOR_ENDPOINTS.CAMPAIGN.MY_CAMPAIGNS.replace(":creatorId", creatorId),
    null,
    requestType.GET,
  );
};

const getCreatorCampaignDetail = (creatorId, campaignId) => {
  return Api(
    CREATOR_ENDPOINTS.CAMPAIGN.DETAIL.replace(":creatorId", creatorId).replace(
      ":campaignId",
      campaignId,
    ),
    null,
    requestType.GET,
  );
};

const participateInCampaign = (creatorId, campaignId) => {
  return Api(
    CREATOR_ENDPOINTS.CAMPAIGN.PARTICIPATE.replace(
      ":creatorId",
      creatorId,
    ).replace(":campaignId", campaignId),
    null,
    requestType.POST,
  );
};

const submitCampaignVideo = (creatorId, campaignId, params) => {
  return Api(
    CREATOR_ENDPOINTS.CAMPAIGN.SUBMIT_VIDEO.replace(
      ":creatorId",
      creatorId,
    ).replace(":campaignId", campaignId),
    params,
    requestType.PUT,
  );
};

const markCampaignVideoPosted = (creatorId, campaignId, params) => {
  return Api(
    CREATOR_ENDPOINTS.CAMPAIGN.MARK_POSTED.replace(
      ":creatorId",
      creatorId,
    ).replace(":campaignId", campaignId),
    params,
    requestType.PUT,
  );
};

export {
  getCreatorCampaigns,
  getCreatorAcceptedCampaigns,
  getCreatorCampaignDetail,
  participateInCampaign,
  submitCampaignVideo,
  markCampaignVideoPosted,
};
